document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-products-slider-2026="true"]');

  sections.forEach((section) => {
    const sliders = section.querySelectorAll('.ProductsSlider__swiper');

    sliders.forEach((instance) => {
      if (instance.dataset.swiperInitialized === 'true') return;

      const checkSwiperLoadedInterval = setInterval(() => {
        if (typeof Swiper !== 'undefined' && instance) {
          new Swiper(instance, {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 14,
            loop: true,
            centeredSlides: false,
            watchOverflow: true,
            breakpoints: {
              640: {
                slidesPerView: 3,
              },
              960: {
                slidesPerView: 4,
              },
              1280: {
                slidesPerView: 5,
              },
            },
            navigation: {
              nextEl: `#next-${instance.getAttribute('id')}`,
              prevEl: `#prev-${instance.getAttribute('id')}`,
            },
          });
          instance.dataset.swiperInitialized = 'true';
          clearInterval(checkSwiperLoadedInterval);
        }
      }, 200);
    });
  });
});
